export enum BrandActionTypes {
    GET_BRAND_DETAIL = 'GET_BRAND_DETAIL',
    GET_BRAND_SOCIAL_CONFIG = 'GET_BRAND_SOCIAL_CONFIG',
    GET_BRAND_CONFIG = 'GET_BRAND_CONFIG',
}
